import { IOrgMember } from '@/types/IOrgMember';
import { Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react';
import Member from './components/member/member.view';

interface IPartnersTableProps {
	members: Array<IOrgMember>;
	onRemoveMember: (memberId: string) => Promise<void>;
}

export default function MembersTable(props: IPartnersTableProps) {
	return (
		<TableContainer overflowY="auto">
			<Table bg="white" borderTopRadius="md" h="full" overflow="auto">
				<Thead>
					<Tr bg="blackAlpha.100">
						<Th>Info</Th>
						<Th isNumeric>Actions</Th>
					</Tr>
				</Thead>
				<Tbody>
					{props.members.map((member) => (
						<Member key={member.id} member={member} onRemoveMember={props.onRemoveMember} />
					))}
				</Tbody>
			</Table>
		</TableContainer>
	);
}
